import React, { useState, useEffect } from 'react';
import { X, Loader2, Image as ImageIcon } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import api from '../utils/api';

const TYPES = [['','All'],['photo','Photos'],['video','Videos']];

export default function GalleryPage() {
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [type, setType]     = useState('');
  const [lb, setLb]         = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get(`/gallery?limit=60${type?`&type=${type}`:''}`).then(r => setItems(r.data.items||[])).catch(()=>setItems([])).finally(()=>setLoading(false));
  }, [type]);

  const HEIGHTS = [200,280,240,320,200,260,220,300,180,240];

  return (
    <div className="min-h-screen bg-gray-50 font-body">
      <Navbar />
      <div className="pt-20">
        <section className="relative bg-hero-gradient py-16 overflow-hidden">
          <div className="absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAgTSAwIDIwIEwgNDAgMjAgTSAyMCAwIEwgMjAgNDAgTSAwIDMwIEwgNDAgMzAgTSAzMCAwIEwgMzAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzIwMjA2MCIgc3Ryb2tlLXdpZHRoPSIwLjUiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] " />
          <div className="relative max-w-7xl mx-auto px-6 text-center">
            <span className="section-tag border-gold-400/30 text-gold-300 bg-gold-500/10 mb-5">Our Work in Pictures</span>
            <h1 className="font-display text-4xl lg:text-5xl font-bold text-white mb-4">Gallery</h1>
            <p className="text-white/60 text-lg max-w-xl mx-auto">Photos and videos from our programs, events, and community impact across Nigeria.</p>
          </div>
        </section>

        <section className="py-12">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex gap-2 justify-center mb-8">
              {TYPES.map(([v,l]) => <button key={v} onClick={()=>setType(v)} className={`px-5 py-2 rounded-full text-sm font-semibold border-2 transition-all ${type===v?'bg-royal-800 border-royal-800 text-white':'border-gray-200 text-gray-600 hover:border-royal-300 bg-white'}`}>{l}</button>)}
            </div>
            {loading ? (
              <div className="flex items-center justify-center h-48 gap-2 text-gray-400"><Loader2 size={22} className="animate-spin"/>Loading...</div>
            ) : items.length === 0 ? (
              <div className="text-center py-20 text-gray-400"><ImageIcon size={40} className="mx-auto mb-3 opacity-30"/><p>No media uploaded yet.</p></div>
            ) : (
              <div style={{columns:'3 280px', gap:'12px'}}>
                {items.map((item,i) => (
                  <div key={item._id} onClick={()=>setLb(item)} className="relative cursor-pointer mb-3 overflow-hidden rounded-2xl bg-hero-gradient group"
                    style={{height: HEIGHTS[i%HEIGHTS.length], breakInside:'avoid', display:'block'}}>
                    {item.url ? (item.type==='video'
                      ? <video src={item.url} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
                      : <img src={item.thumbUrl||item.url} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>)
                      : <div className="flex items-center justify-center h-full"><ImageIcon size={36} className="text-white/20"/></div>}
                    {item.type==='video' && <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-gold-500/90 rounded-full flex items-center justify-center text-lg">▶</div>}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                      <div><h4 className="text-white font-semibold text-sm">{item.title}</h4>{item.description&&<p className="text-white/60 text-xs mt-0.5">{item.description}</p>}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>

      {lb && (
        <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4" onClick={()=>setLb(null)}>
          <button className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"><X size={18}/></button>
          <div className="max-w-4xl w-full" onClick={e=>e.stopPropagation()}>
            {lb.url ? (lb.type==='video'
              ? <video src={lb.url} controls className="w-full max-h-[75vh] rounded-2xl"/>
              : <img src={lb.url} alt={lb.title} className="w-full max-h-[75vh] object-contain rounded-2xl"/>)
              : <div className="h-64 bg-royal-800 rounded-2xl flex items-center justify-center"><ImageIcon size={48} className="text-white/20"/></div>}
            <div className="text-center mt-4">
              <h3 className="text-white font-display font-semibold text-lg">{lb.title}</h3>
              {lb.description && <p className="text-white/50 text-sm mt-1">{lb.description}</p>}
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}
